import React from 'react';
import { Link } from "react-router-dom";
import loading_gif from '../Images/loading.gif';
import WebPubLogo from '../Images/WebPub-logo.svg';
import './PasswordReset.css';

class PasswordReset extends React.Component {
	constructor(props) {
		super(props);
		let params = new URLSearchParams(this.props.location.search);
		this.state = {
			token: params.get('t'),
			isLoaded: false,
			message: null,
			error: false,
			passwordText: '',
			passwordConfirm: '',
			userId: null
		};
		
		this.passwordTextChange = this.passwordTextChange.bind(this);
		this.passwordConfirmChange = this.passwordConfirmChange.bind(this);
		this.resetPasswordSubmit = this.resetPasswordSubmit.bind(this);
		this.validateToken = this.validateToken.bind(this);
	}
	
	// Handle input changes
	passwordTextChange(changeEvent) {
		this.setState({
			passwordText: changeEvent.target.value,
			message: null
		});
	}
	
	// Handle input changes
	passwordConfirmChange(changeEvent) {
		this.setState({
			passwordConfirm: changeEvent.target.value,
			message: null
		});
	}
	
	// User is trying to submit their passwords. Validate and confirm
	resetPasswordSubmit() {
		const pwVal = this.state.passwordText;
		const confirmVal = this.state.passwordConfirm;
		
		// Frontend validation is to inform users. Backend validation is to prevent bad data.
		// Both are necessary.
		if (pwVal !== confirmVal) { // Get it together, user.
			this.setState({
				message: 'Passwords do not match'
			});
			return;
		}
		if (pwVal.length < 8) { // ex: abc123.
			this.setState({
				message: 'Password must be at least 8 characters'
			});
			return;
		}
		if (pwVal.length > 32) { // ex: IAmTheVeryModel0fAModernMajorGeneralIveInformationVegetableAnimalAndMineral!
			this.setState({
				message: 'Password cannot be more than 32 characters'
			});
			return;
		}
		if (pwVal.toUpperCase() === pwVal) { // ex: PASSWORD1.
			this.setState({
				message: 'Password must contain at least one lower-case letter'
			});
			return;
		}
		if (pwVal.toLowerCase() === pwVal) { // ex: password1.
			this.setState({
				message: 'Password must contain at least one upper-case letter'
			});
			return;
		}
		if (!new RegExp("[0-9]").test(pwVal)) { // ex: Password.
			this.setState({
				message: 'Password must contain at least one digit'
			});
			return;
		}
		if (!new RegExp("[^a-zA-Z0-9 ]").test(pwVal)) { // ex: Password1
			this.setState({
				message: 'Password must contain at least one special character'
			});
			return;
		}
		
		// You passed inspection. Submitting password
		fetch('/webpub-services/auth/resetPassword',
			{
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					userId: this.state.userId,
					password: pwVal,
					token: this.state.token
				})
			}
		)
		.then((res) => res.json())
		.then(
			(response) => {
				if (response.success && response.success === 'true') { // It worked!
					this.setState({
						message: response.message,
						error: false
					}, () => {this.props.history.push("/login")});
				}
				else if (response.success) { // The value exists, but it's not "true"
					this.setState({
						message: response.message,
						error: true
					});
				}
				else { // Something happened. I don't know what.
					this.setState({
						message: 'An unknown error occurred. Please try again later. (PR107)',
						error: true
					});
				}
			}
		);
	}

	validateToken() {
		const token = this.state.token;
		if (!token || token.length === 0) { // This is already broken. Skip.
			this.setState({
				message: 'This token has expired or is invalid. Please send another Forgot Password request and try again.',
				error: true
			});
			return;
		}
		
		fetch('/webpub-services/wPPasswordTokenAPI/validateToken?token=' + token, {method: 'GET'})
		.then(res => res.json())
		.then(
			(response) => {
				if (response.id) { // Success!
					this.setState({
						error: false,
						message: '',
						isLoaded: true,
						userId: response.userId
					});
				}
				else if (response.token) { // Token should have a failure message
					this.setState({
						error: true,
						message: response.token
					});
				}
				else {
					this.setState({
						error: true,
						message: 'Error: Failed to contact authentication service. Please contact KITE support. (PR110)'
					})
				}
			}
		);
	}
	
	// Initial page load
	componentDidMount() {
		this.validateToken();
	}

	render() {
		// Sanity checking
		if (this.state.error) {
			return (
				<div className='app-container'>
					<div className='password-reset'>
						<Link to='/login'>
							<img src={WebPubLogo} alt='logo' style={{ height: 135, paddingTop: 10 }} />
						</Link>
						<div className='panel_center_hdr'>
							ENTER NEW PASSWORD
						</div>
						<p className='display-message'>{this.state.message}</p>
					</div>
					<div className='app-footer'>© {new Date().getFullYear()} University of Kansas</div>
				</div>
			);
		} 
		else if (!this.state.isLoaded) { // Display nothing until we're ready for user input
			return <div>Loading <img src={loading_gif} alt='loading gif' style={{ verticalAlign: 'middle' }} /></div>;
		}
		
		return (
		<div className='app-container'>
			<div className='password-reset'>
				<Link to='/login'>
					<img src={WebPubLogo} alt='logo' style={{ height: 135, paddingTop: 10 }} />
				</Link>
				<div className='panel_center_hdr'>
					ENTER NEW PASSWORD
				</div>
				<div id='password-input'>
					<input
						type='password'
						minLength={8}
						maxLength={33}
						placeholder='Enter password'
						value={this.state.passwordText}
						onChange={this.passwordTextChange}
					/>
				</div>
				<br />
				<div id='password-confirm'>
					<input
						type='password'
						minLength={8}
						maxLength={33}
						placeholder='Confirm password'
						value={this.state.passwordConfirm}
						onChange={this.passwordConfirmChange}
					/>
				</div>
				<p className='display-message'>{this.state.message}</p>
				<div 
					className='password-reset-button clickable'
					onClick={this.resetPasswordSubmit}
				>
					Submit
				</div>
			</div>
			<div className='app-footer'>© {new Date().getFullYear()} University of Kansas</div>
		</div>
		);
	}
}
export default PasswordReset;